/// <reference path="../../../ts/libs.ts" />
import { ButtonProps, ButtonType, ButtonWidget, Img, InteractionState } from '@tableau/widgets';

import * as React from 'react';

import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../../../common/react/CommonStyles';

import { imgPath } from '../../../common/utilities/ImgUrl';
import { PageHeaderStyles } from '../../layout/PageHeaderStyles';

const DEFAULT_ICON_PATH = imgPath('spaces_header_device_preview.svg');
const ACTIVE_ICON_PATH = imgPath('spaces_header_device_preview_active.svg');

function getPreviewButtonContent(displayOnlyIcons: boolean): ((state: InteractionState) => JSX.Element) {
  return (state: InteractionState): JSX.Element => {
    const buttonText = Messages.previewDeviceLayouts();

    const iconSize = 20;

    const iconStyle = displayOnlyIcons? PageHeaderStyles.iconOnlyButton : PageHeaderStyles.iconForTextButton;

    const imgProps: React.ImgHTMLAttributes<HTMLImageElement> = {
      draggable: false,
      height: iconSize,
      width: iconSize,
      src: state.hover ? ACTIVE_ICON_PATH : DEFAULT_ICON_PATH,
      style: iconStyle
    };

    return (
      <div className={PageHeaderStyles.TextButton}>
        <Img {...imgProps} />
        {!displayOnlyIcons && buttonText }
      </div>
    );
  };
}

export function DevicePreviewButton(props: DevicePreviewButton.Props):
  React.ReactElement<DevicePreviewButton.Props> {
    const { handleClick, displayOnlyIcons } = props;

    const buttonStyle = {
      marginLeft: CommonStyles.Sizes.DefaultSpace,
      display: 'inline-block',
      cursor: 'pointer'
    };

    const testId = 'toggle-device-preview-mode';

    const iconButtonProps: ButtonProps = {
      buttonType: ButtonType.IconOutline,
      getContent: getPreviewButtonContent(displayOnlyIcons),
      testId: testId,
      handleClick: handleClick,
      style: buttonStyle,
      title: Messages.deviceLayoutsTooltip()
    };

    return (
        <ButtonWidget {...iconButtonProps} />
    );
  }

export namespace DevicePreviewButton {
  export interface Props {
    readonly handleClick: () => void;
    readonly displayOnlyIcons: boolean;
  }
}
